module.exports = __webpack_public_path__ + "img/otp-image.41c9761.svg";